import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";

function getYears() {
  const current = new Date().getFullYear();
  const years = [];
  for (let y = current; y >= 2020; y--) {
    years.push(y);
  }
  return years;
}

export default function Report() {
  const { http, user } = AuthUser();
  const [tasks, setTasks] = useState([]);
  const [remark, setRemark] = useState(null);
  const [date, setDate] = useState(null);
  const [departments, setdepartments] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loginUser, setloginUser] = useState(user.department_id);
  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear().toString()
  );
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selCurrMonth, setCurrMonth] = useState("");
  const [selectedDepartment, setselectedDepartment] = useState("");
  const [departmetsall, setdepartmentsall] = useState([]);
  
  // Initialize current month on component mount
  useEffect(() => {
    const currentDate = new Date();
    const currentMonthNumber = currentDate.getMonth() + 1; // JavaScript months are zero-based
    setSelectedMonth(currentMonthNumber.toString());
  }, []);

  useEffect(() => {
    http.get(`/departments?login_user=${user.id}`).then((res) => {
      setdepartmentsall(res.data.data);
    });
    
    const currentDate = new Date();
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const monthNames = {
      1: "Jan",
      2: "Feb",
      3: "Mar",
      4: "Apr",
      5: "May",
      6: "Jun",
      7: "Jul",
      8: "Aug",
      9: "Sep",
      10: "Oct",
      11: "Nov",
      12: "Dec",
    };

    const currentMonthAbbreviation = months[currentDate.getMonth()];
    setCurrMonth(
      selectedMonth == "" ? currentMonthAbbreviation : monthNames[selectedMonth]
    );
    fetchTaskDetails(selectedMonth, selectedYear, selectedDepartment);
  }, [selectedMonth, selectedYear, selectedDepartment]);

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleDepartmentChange = (event) => {
    setselectedDepartment(event.target.value);
  };

  const fetchTaskDetails = (month = "", year = "", department = "") => {
    setIsLoading(true);
    let selectedMonth;
    if (month === "") {
      // If month is empty, use the current month
      selectedMonth = new Date().getMonth() + 1; // JavaScript months are zero-based
    } else {
      // If month is provided, use it as is
      selectedMonth = month;
    }

    let endpoint = `/report?month=${selectedMonth}&year=${year}&department=${department}&login_user=${user.id}`;

    http
      .get(endpoint)
      .then((res) => {
        setIsLoading(false);
        if (Array.isArray(res.data.data)) {
          setTasks(res.data.data);
        } else {
          setIsLoading(false);
          console.error("API response is not an array");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching tasks:", error);
      });
  };

  // Function to handle export
  const handleExport = () => {
    // Create the Excel headings
    const headings = [
      "Name",
      "Month",
      "Total Tasks",
      "Percentage",
      "Department",
      "Completed",
      "Pending",
      "Revision",
      "Progress",
      "Delayed",
      "Finished",
    ];

    // Format the data you want to export
    const formattedData = tasks.map((user) => [
      `${user.user.name} ${user.user.last_name}`,
      selectedMonth === "" ? "All" : selectedMonth,
      user.total_tasks,
      `${user.TotalPercentage} %`,
      user.department,
      user.Completed,
      user.Pending,
      user.Revised,
      user.Progress,
      user.Delayed,
      user.Finished,
    ]);

    // Combine headings and data
    const dataWithHeadings = [headings, ...formattedData];

    // Convert the data to CSV format
    const csvData = dataWithHeadings
      .map((row) => row.map((value) => `"${value}"`).join(","))
      .join("\n");

    // Create a Blob for downloading the CSV file
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    // Create a temporary link and trigger the download
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = "report.csv";
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const years = getYears();

  return (
    <>
      <Toaster />
      <div className="container mt-1">
        {user && user.department_id == 1 && (
          <div className="row">
            <div className="form-group text-end col-md-4">
              <select
                onChange={handleDepartmentChange}
                className="form-control"
              >
                <option value="">Select Department</option>
                <option value="">All Department</option>
                {departmetsall.map((depart) => (
                  <option key={depart.id} value={depart.id}>
                    {depart.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group text-end col-md-4">
              <select onChange={handleMonthChange} value={selectedMonth} className="form-control">
                <option value="">Select Month</option>
                <option value="">All Month</option>
                <option value="1">Jan</option>
                <option value="2">Feb</option>
                <option value="3">Mar</option>
                <option value="4">Apl</option>
                <option value="5">May</option>
                <option value="6">Jun</option>
                <option value="7">Jul</option>
                <option value="8">Aug</option>
                <option value="9">Sep</option>
                <option value="10">Oct</option>
                <option value="11">Nov</option>
                <option value="12">Dec</option>
              </select>
            </div>

            <div className="form-group text-end col-md-2">
              <select
                onChange={handleYearChange}
                value={selectedYear}
                className="form-control"
              >
                {years.map((year, index) => (
                  <option key={year} value={year}>
                    {index === 0
                      ? `Current Year-${year}`
                      : index === 1
                        ? `Previous Year-${year}`
                        : year}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
              <button
                onClick={handleExport}
                className="button btn btn-small btn-warning"
              >
                Export
              </button>
            </div>
          </div>
        )}
        <h1>Reports ({selCurrMonth})</h1>
        <div className="table-responsive">
          {isLoading ? (
            <TaskSkeleton />
          ) : (
            <table className="table table-striped">
              <thead className="table-primary">
                <tr>
                  <th>No</th>
                  <th>Name</th>
                  <th>Month</th>
                  <th>Total Tasks</th>
                  <th>Percentage</th>
                  <th>Department</th>
                  <th>Completed</th>
                  <th>Finished</th>
                  <th>Pending</th>
                  <th>Revision</th>
                  <th>Progress</th>
                  <th>Delayed</th>
                  <th>Delayed Completed</th>

                  {/* Add other fields as necessary */}
                </tr>
              </thead>
              <tbody>
                {tasks.map((user_rep, index) => {
                  if (user.department_id === 1) {
                    return (
                      <tr key={user_rep.user.id}>
                        <td>{index + 1}</td>
                        <td className="text-uppercase">
                          {user_rep.user.name} {user_rep.user.last_name}
                        </td>
                        <td>
                          {selectedMonth.length === 0 ? "All" : selectedMonth}
                        </td>
                        <td>{user_rep.total_tasks}</td>
                        <td className="primary text-danger bold fw-bold">
                          {user_rep.TotalPercentage} %
                        </td>
                        <td>{user_rep.department}</td>
                        <td>{user_rep.Completed}</td>
                        <td>{user_rep.Finished}</td>
                        <td>{user_rep.Pending}</td>
                        <td>{user_rep.Revised}</td>
                        <td>{user_rep.Progress}</td>
                        <td>{user_rep.Delayed}</td>
                        <td>{user_rep.delayed_completed}</td>
                      </tr>
                    );
                  } else if (user.department_id !== 1 && user.id === user_rep.user.id) {
                    return (
                      <tr key={user_rep.user.id}>
                        <td>{index + 1}</td>
                        <td className="text-uppercase">
                          {user_rep.user.name} {user_rep.user.last_name}
                        </td>
                        <td>
                          {selectedMonth.length === 0 ? "All" : selectedMonth}
                        </td>
                        <td>{user_rep.total_tasks}</td>
                        <td className="primary text-danger bold fw-bold">
                          {user_rep.TotalPercentage} %
                        </td>
                        <td>{user_rep.department}</td>
                        <td>{user_rep.Completed}</td>
                        <td>{user_rep.Pending}</td>
                        <td>{user_rep.Revised}</td>
                        <td>{user_rep.Progress}</td>
                        <td>{user_rep.Delayed}</td>
                        <td>{user_rep.delayed_completed}</td>
                      </tr>
                    );
                  } else {
                    // If neither condition is met, you can choose to return null or handle it accordingly
                    return null;
                  }
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
